import { onMounted, ref } from 'vue'

export const useIsMounted = () => {
    const isMounted = ref(false)
    onMounted(() => {
        isMounted.value = true
    })
    return isMounted
}
